import dayjs, { Dayjs } from 'dayjs'

/**
 * 처리 기한 판정 (화면 명세 6절)
 *
 * 명세의 기한은 "환불 사유 확인일로부터 **3영업일**" 인데, 서버가 내려주는
 * `RefundLedgerRow.elapsedDays` 는 **달력일**이다. 둘을 같은 값으로 쓰면 금요일 접수 건이
 * 월요일에 이미 기한 초과로 뜬다.
 *
 * ⚠️ 공휴일은 세지 않는다. 주말만 제외하는 근사치이고, 그래서 연휴 구간에서는 실제보다 기한이
 * 이르게 잡힌다. 공휴일 달력을 붙이려면 출처(서버 설정·외부 API)를 정해야 하는데 이 화면
 * 하나를 위해 들일 비용이 아니라고 봤다. **초과 표시는 주의 환기이지 판정이 아니다.**
 */

/** 처리 기한. 명세 6절 */
export const REFUND_DEADLINE_BUSINESS_DAYS = 3

/** 시작일 다음 날부터 기준일까지의 영업일 수. 같은 날이면 0 */
export const businessDaysBetween = (from: Dayjs, to: Dayjs): number => {
  const start = from.startOf('day')
  const end = to.startOf('day')
  if (!end.isAfter(start)) return 0

  let count = 0
  let cursor = start.add(1, 'day')
  while (!cursor.isAfter(end)) {
    const day = cursor.day()
    if (day !== 0 && day !== 6) count += 1
    cursor = cursor.add(1, 'day')
  }
  return count
}

/**
 * 접수 후 기한을 넘겼나. 넘겼으면 경과 영업일 수를, 아니면 null 을 준다.
 *
 * 처리가 끝난 행(처리 완료·철회)은 기한을 따지지 않는다 — 이미 손을 떠났다.
 */
export const overdueBusinessDays = (createdAt?: string | null, settled?: boolean): number | null => {
  if (settled || !createdAt) return null
  const elapsed = businessDaysBetween(dayjs(createdAt), dayjs())
  return elapsed > REFUND_DEADLINE_BUSINESS_DAYS ? elapsed : null
}
